export const getDay = (date: string) => {
  const days = ["Sun", "Mon", "Tue", "Mar", "Wed", "Thu", "Fri", "Sat"];
  const enrollmentEndDate = new Date(date);

  return days[enrollmentEndDate.getDay()];
};

export const getMonth = (date: string) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const enrollmentEndDate = new Date(date);

  return months[enrollmentEndDate.getMonth()];
};

export function videoTime(secs: string | number, trimMinutes = true) {
  let sec_num = parseInt(secs.toString(), 10);
  let hours = Math.floor(sec_num / 3600).toString();
  let minutes = Math.floor((sec_num - Number(hours) * 3600) / 60).toString();
  let seconds = (sec_num - Number(hours) * 3600 - Number(minutes) * 60).toString();

  if (Number(hours) < 10) {
    hours = "0" + hours;
  }

  if (Number(minutes) < 10 && !trimMinutes) {
    minutes = "0" + minutes;
  }

  if (Number(seconds) < 10) {
    seconds = "0" + seconds;
  }

  if (Number(hours) > 0) {
    return hours + ":" + minutes + ":" + seconds;
  } else {
    return minutes + ":" + seconds;
  }
}

export function getStreamingAudioURL(audioURL: string) {
  if (!audioURL) {
    return audioURL;
  }

  let cloudinarySplit = audioURL.split("/upload/");

  // make sure it's a cloudinary url so we can get the stream
  if (cloudinarySplit.length === 2) {
    // removing vc_auto for now.
    let newAudioURL = cloudinarySplit[0] + "/upload/af_iaf/" + cloudinarySplit[1];
    newAudioURL = newAudioURL.substr(0, newAudioURL.lastIndexOf(".")) + ".m3u8";
    //console.log("THE NEW AUDIO URL ", newAudioURL)
    return newAudioURL;
  } else {
    return audioURL;
  }
}

export const formatCloudinaryAudioMediaLink = (projectMediaLink: string) => {
  if (!projectMediaLink.includes("cloudinary")) {
    // No additional formatting for non-cloudinary links
    return projectMediaLink;
  }

  const splitArray = projectMediaLink.split(".");
  // Ensure link has file extension
  if (splitArray.length === 1 || (splitArray[0] === "" && splitArray.length === 2)) {
    return projectMediaLink;
  }

  // Modify file extension if necessary
  // Not all browsers support playback of m4a, so change the file extension of
  // Cloudinary URLs with .m4a extensions to .mp3, which will auto convert the file.
  if (splitArray.pop()?.toLowerCase() === "m4a") {
    const lastIndex = projectMediaLink.lastIndexOf(".");
    const fileName = projectMediaLink.slice(0, lastIndex);
    return `${fileName}.mp3`;
  }

  return projectMediaLink;
};
